module.exports = require("./sat-Olck.d.ts");